// extracted by mini-css-extract-plugin
export default {"window":"GameWindow_window__YQozQ"};